import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStatus } from '../hooks/useAuthStatus';
import { useAuthStore } from '../lib/store'; // Import the auth store
import { Loader2 } from 'lucide-react';

export function ProtectedRoute() {
  const { isAuthenticated, isAdmin, isSuperAdmin, isManager, isLoading } = useAuthStatus();
  // Get hasAccess directly from the auth store
  const hasAccess = useAuthStore((state) => state.hasAccess);
  const location = useLocation();
  const [isCheckingAccess, setIsCheckingAccess] = useState(true);
  const [hasComponentAccess, setHasComponentAccess] = useState(false);

  useEffect(() => {
    const checkComponentAccess = async () => {
      if (!isLoading && isAuthenticated) {
        // Exact path (for direct component access check)
        const exactPath = location.pathname;
        
        // Check if path requires document category access
        // Check for /admin/documentos
        const isDocumentsPage = exactPath === '/admin/documentos';
        
        // If super admin, they have access to everything
        if (isSuperAdmin) {
          setHasComponentAccess(true);
          setIsCheckingAccess(false);
          return;
        }
        
        // Check specific component access
        let access = hasAccess(exactPath);
        
        console.log(`[ProtectedRoute] Checking access to ${exactPath}: ${access ? 'GRANTED' : 'DENIED'}`);
        
        setHasComponentAccess(access);
        setIsCheckingAccess(false);
      }
    };
    
    checkComponentAccess();
  }, [isLoading, isAuthenticated, location.pathname, hasAccess, isSuperAdmin, isAdmin, isManager]);

  if (isLoading || isCheckingAccess) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="text-center">
          <Loader2 className="w-12 h-12 text-blue-600 animate-spin mx-auto" />
          <p className="mt-4 text-primary-800 dark:text-primary-200">
            Verificando autorização...
          </p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    console.log(
      '[ProtectedRoute] User not authenticated, redirecting to login.'
    );
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Allow access if user is Super Admin or has required permissions
  if (!isSuperAdmin && !hasComponentAccess) {
    console.log(
      `[ProtectedRoute] User is authenticated but not authorized for ${location.pathname}, redirecting to forbidden.`
    );
    return <Navigate to="/forbidden" state={{ from: location }} replace />;
  }

  return <Outlet />;
}